<template>
  <b-nav-item-dropdown id="dropdown-grouped" variant="link" class="dropdown-language" right >

    <template #button-content>
      <b-img :src="currentLocale.img" height="14px" width="22px" :alt="currentLocale.locale" />
      <span class="ml-50 text-body">{{ $t(currentLocale.name) }}</span>
    </template>

    <b-dropdown-item v-for="localeObj in locales" :key="localeObj.locale" @click="changeLocale(localeObj.locale)" >
      <b-img :src="localeObj.img" height="14px" width="22px" :alt="localeObj.locale" />
      <span class="ml-50">{{ $t(localeObj.name) }}</span>
    </b-dropdown-item>

  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from 'bootstrap-vue'
import { localize } from 'vee-validate';
import i18n from '@/libs/i18n'
import en from 'vee-validate/dist/locale/en.json'
import es from 'vee-validate/dist/locale/es.json'

export default {
  components: { BNavItemDropdown, BDropdownItem, BImg, },
  methods: {
    changeLocale : function(data){
      i18n.locale = data;
      localStorage.setItem("locale", i18n.locale);
      switch (i18n.locale) {
        case 'es':
            localize('es', es)
            break;
        case 'en':
            localize('en', en)
            break;
        default:
            localize('es', es)
            break;
      }
    }
  },  
  computed: {
    currentLocale() {
      return this.locales.find(l => l.locale === this.$i18n.locale)
    },
  },
  setup() {
    /* eslint-disable global-require */
    const locales = [
      {
        locale: 'es',
        img: require('@/assets/images/flags/es.png'),
        name: 'Spanish',
      },
      {
        locale: 'gl',
        img: require('@/assets/images/flags/gl.png'),
        name: 'Galician',
      },
      {
        locale: 'en',
        img: require('@/assets/images/flags/en.png'),
        name: 'English',
      },
      // {
      //   locale: 'fr',
      //   img: require('@/assets/images/flags/fr.png'),
      //   name: 'French',
      // },
      // {
      //   locale: 'de',
      //   img: require('@/assets/images/flags/de.png'),
      //   name: 'German',
      // },
      // {
      //   locale: 'pt',
      //   img: require('@/assets/images/flags/pt.png'),
      //   name: 'Portuguese',
      // },
    ]
    /* eslint-disable global-require */

    return {
      locales,
    }
  },
}
</script>

<style>

</style>
